import { render, staticRenderFns } from "./ABomTable.vue?vue&type=template&id=62bc8310&"
import script from "./ABomTable.vue?vue&type=script&lang=js&"
export * from "./ABomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports